// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3syFl","subheader":"ReorderModal_subheader__dmmwY","listWrap":"ReorderModal_listWrap__LvZrn"};